import React from "react";
import SharedForPublic from "src/components/Shared/sharedForPublic";

interface IContainer {
    isKey: boolean;
}

const Container: React.FC<IContainer> = ({
	isKey,
	children
}) => {
	if(isKey)
		return <SharedForPublic>
			{children}
		</SharedForPublic>;
	return <> {children} </>;
};

export default Container;
